import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "left" }
const _hoisted_2 = {
  key: 0,
  class: "value"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "value"
}
const _hoisted_5 = {
  key: 2,
  class: "value"
}
const _hoisted_6 = { class: "mono" }
const _hoisted_7 = { class: "api-key-container" }
const _hoisted_8 = { class: "mono" }
const _hoisted_9 = { class: "right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editable_block_input = _resolveComponent("editable-block-input")!
  const _component_form_select = _resolveComponent("form-select")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_clipable = _resolveComponent("clipable")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_editable_block = _resolveComponent("editable-block")!

  return (_openBlock(), _createBlock(_component_editable_block, {
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:supplier-catalogue', _ctx.supplierCatalogue?.sys?.id, $event))),
    title: "Catalogue settings",
    layout: "grid",
    "model-value": _ctx.supplierCatalogue,
    "column-count": 2
  }, {
    default: _withCtx(({ editState }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_editable_block_input, {
          label: "Name",
          modelValue: editState.name,
          "onUpdate:modelValue": ($event: any) => ((editState.name) = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_editable_block_input, {
          label: "Tags",
          "model-value": editState.tags?.join(', '),
          "onUpdate:modelValue": ($event: any) => (editState.tags = $event?.split(','))
        }, null, 8, ["model-value", "onUpdate:modelValue"]),
        _createVNode(_component_editable_block_input, {
          label: "Supplier",
          modelValue: editState.supplier,
          "onUpdate:modelValue": ($event: any) => ((editState.supplier) = $event),
          error: !editState.supplier
        }, {
          static: _withCtx(({ inputState }) => [
            _createElementVNode("span", null, _toDisplayString(_ctx.supplierOptions?.find(co => co.value === (typeof inputState.value === 'object' ? inputState.value?.sys?.id : inputState.value))?.label), 1)
          ]),
          input: _withCtx(({ inputState }) => [
            _createVNode(_component_form_select, {
              "model-value": _ctx.supplierOptions?.find(co => co.value === (typeof inputState.value === 'object' ? inputState.value?.sys?.id : inputState.value)),
              onSelect: e => inputState.value = e.value,
              type: "select",
              label: inputState.label,
              placeholder: "Choose a supplier",
              options: _ctx.supplierOptions
            }, null, 8, ["model-value", "onSelect", "label", "options"])
          ]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "error"]),
        _cache[24] || (_cache[24] = _createElementVNode("h6", { class: "label medium" }, "API Key", -1)),
        (editState.supplier?.token?.access_token?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", {
                class: _normalizeClass(["cursor-pointer", {'has-tooltip': editState.service?.id.startsWith('S_'), locked: editState.service?.id.startsWith('S_') }]),
                "data-tooltip": "The API Key for this channel cannot be changed, as it is connected to another Directify space",
                onClick: () => editState.service?.id.startsWith('S_') ? undefined : _ctx.showTokenModal = true
              }, _toDisplayString(editState.supplier.token.access_token.substring(0,5)+'...'+editState.supplier.token.access_token.substring(editState.supplier.token.access_token.length-5)), 11, _hoisted_3)
            ]))
          : (!_ctx.readonly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_q_btn, {
                  unelevated: "",
                  rounded: "",
                  color: "primary",
                  disable: _ctx.supplierCatalogue.supplier ? false : true,
                  onClick: _ctx.showChannelTokenModal,
                  style: {"margin-top":"-8px"}
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("Generate new API key")
                  ])),
                  _: 1
                }, 8, ["disable", "onClick"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, "No Api Key set")),
        _createVNode(_component_q_dialog, {
          class: "api-key-dialog",
          modelValue: _ctx.showTokenModal,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showTokenModal) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card, null, {
              default: _withCtx(() => [
                (!_ctx.supplierCatalogue.supplier?.token?.access_token)
                  ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                      default: _withCtx(() => [
                        _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "bold space-v2" }, "New Channel API Key", -1)),
                        _cache[8] || (_cache[8] = _createElementVNode("span", null, "This will set the API key for this channel, giving API access to information, orders and products related to this channel.", -1)),
                        _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                        _cache[10] || (_cache[10] = _createElementVNode("u", null, "Copy it to a safe location, after confirming you will not be able to view the key again", -1)),
                        _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                        _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                        _cache[13] || (_cache[13] = _createElementVNode("a", {
                          href: "https://protiumdigital.notion.site/Orders-Fulfillments-API-2c81df0e539949afb2061227f3aeaf74",
                          target: "_blank"
                        }, "API docs", -1)),
                        _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                        _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                        _createVNode(_component_clipable, {
                          class: "api-key-clipable",
                          payload: _ctx.channelToken,
                          message: "API Key copied to clipboard"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.channelToken), 1)
                          ]),
                          _: 1
                        }, 8, ["payload"]),
                        _createVNode(_component_q_btn, {
                          unelevated: "",
                          rounded: "",
                          color: "primary",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveChannelToken(_ctx.channelToken)))
                        }, {
                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                            _createTextVNode("Confirm")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_q_btn, {
                          class: "space-h1",
                          unelevated: "",
                          rounded: "",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTokenModal = false))
                        }, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createTextVNode("Cancel")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_q_card_section, { key: 1 }, {
                      default: _withCtx(() => [
                        _cache[18] || (_cache[18] = _createElementVNode("h4", { class: "bold" }, "Supplier API Key", -1)),
                        _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                        _cache[20] || (_cache[20] = _createElementVNode("a", {
                          href: "https://protiumdigital.notion.site/Orders-Fulfillments-API-2c81df0e539949afb2061227f3aeaf74",
                          target: "_blank"
                        }, "API docs", -1)),
                        _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(editState.supplier.token?.access_token.substring(0,5)+'...'+editState.supplier.token?.access_token.substring(editState.supplier.token?.access_token.length-5)), 1)
                        ]),
                        _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
                        _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                        _createVNode(_component_q_btn, {
                          class: "error",
                          unelevated: "",
                          rounded: "",
                          onClick: _ctx.clearChannelToken
                        }, {
                          default: _withCtx(() => _cache[16] || (_cache[16] = [
                            _createTextVNode("Remove key")
                          ])),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_q_btn, {
                          unelevated: "",
                          rounded: "",
                          onClick: _ctx.regenerateChannelToken
                        }, {
                          default: _withCtx(() => _cache[17] || (_cache[17] = [
                            _createTextVNode("Regenerate key")
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_editable_block_input, {
          label: "Shipping time",
          modelValue: editState.shipping_time,
          "onUpdate:modelValue": ($event: any) => ((editState.shipping_time) = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_editable_block_input, {
          label: "Production time",
          modelValue: editState.production_time,
          "onUpdate:modelValue": ($event: any) => ((editState.production_time) = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}